<template>
  <form>
    <div class="row">
      <div class="col-lg-7">
        <h4 class="card-title">{{$t('small_technical_grants.document_upload__application_template_card_title')}}</h4>
        <a
          :href="downloadFiles[0][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appTemplateCompleted">{{$t('small_technical_grants.document_upload__completed_template_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appTemplateCompleted"
            class="upload-file"
            :file-data="GrantForm.files.technical.appTemplateCompleted"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appTemplateCompleted"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appTemplateConsultation">{{$t('small_technical_grants.document_upload__consultation_report_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appTemplateConsultation"
            class="upload-file"
            :file-data="GrantForm.files.technical.appTemplateConsultation"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appTemplateConsultation"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appTemplateCV">{{$t('small_technical_grants.document_upload__staffs_cv_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appTemplateCV"
            class="upload-file"
            :file-data="GrantForm.files.technical.appTemplateCV"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appTemplateCV"
            >
          </upload-file>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.document_upload__applicant_declaration_card_title')}}</h4>
        <a
          :href="downloadFiles[1][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appDeclaration">{{$t('small_technical_grants.document_upload__declaration_signed_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appDeclaration"
            class="upload-file"
            :file-data="GrantForm.files.technical.appDeclaration"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appDeclaration"
            >
          </upload-file>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.document_upload__co_applicant_mandate_card_title')}}</h4>
        <a
          :href="downloadFiles[2][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appCoApplicantMandate">{{$t('small_technical_grants.document_upload__co_applicant_mandate_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appCoApplicantMandate"
            class="upload-file"
            :file-data="GrantForm.files.technical.appCoApplicantMandate"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appCoApplicantMandate"
            >
          </upload-file>
        </div>

        <!--<h4 class="card-title">{{$t('small_technical_grants.document_upload__esms_questionnaire_card_title')}}</h4>-->
        <h4 class="card-title">{{$t('small_technical_grants.4_logical_frame_work')}}</h4>
        <a
          :href="downloadFiles[3][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appLogicalFramework">{{$t('small_technical_grants.document_upload__esms_questionnaire_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appLogicalFramework"
            class="upload-file"
            :file-data="GrantForm.files.technical.appLogicalFramework"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appLogicalFramework"
            >
          </upload-file>
        </div>

        <h4 class="card-title">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_card_title')}}</h4>
        <a
          :href="downloadFiles[4][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appDueDiligenceQuestionnaire">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appDueDiligenceQuestionnaire"
            class="upload-file"
            :file-data="GrantForm.files.technical.appDueDiligenceQuestionnaire"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appDueDiligenceQuestionnaire"
            >
          </upload-file>
        </div>
        <h6>{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_title')}}</h6>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appIncorporationArticles">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_1')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appIncorporationArticles"
            class="upload-file"
            :file-data="GrantForm.files.technical.appIncorporationArticles"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appIncorporationArticles"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appInCountryRegistration">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_2')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appInCountryRegistration"
            class="upload-file"
            :file-data="GrantForm.files.technical.appInCountryRegistration"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appInCountryRegistration"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appTaxCertification">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_3')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appTaxCertification"
            class="upload-file"
            :file-data="GrantForm.files.technical.appTaxCertification"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appTaxCertification"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appLastActivityReport">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_4')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appLastActivityReport"
            class="upload-file"
            :file-data="GrantForm.files.technical.appLastActivityReport"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appLastActivityReport"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appAnualFinancialStataments">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_5')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appAnualFinancialStataments"
            class="upload-file"
            :file-data="GrantForm.files.technical.appAnualFinancialStataments"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appAnualFinancialStataments"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appCodeOfConductPolicies">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_6')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appCodeOfConductPolicies"
            class="upload-file"
            :file-data="GrantForm.files.technical.appCodeOfConductPolicies"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appCodeOfConductPolicies"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appTimesheet">{{$t('small_technical_grants.document_upload__due_diligence_questionnaire_assoc_upload_title_7')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appTimesheet"
            class="upload-file"
            :file-data="GrantForm.files.technical.appTimesheet"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appTimesheet"
            >
          </upload-file>
        </div>

        <h6 style="color: red">{{$t('small_technical_grants.document_upload__additional_info')}}</h6>

        <h4 class="card-title">{{$t('small_technical_grants.document_upload__budget_card_title')}}</h4>
        <a
          :href="downloadFiles[5][$i18n.locale]"
          class="ml-2 btn btn-simple btn-primary"
          >
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>

        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appCompletedBudgetTable">{{$t('small_technical_grants.document_upload__budget_upload_title_1')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appCompletedBudgetTable"
            class="upload-file"
            :file-data="GrantForm.files.technical.appCompletedBudgetTable"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appCompletedBudgetTable"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appQuotes">{{$t('small_technical_grants.document_upload__budget_upload_title_2')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appQuotes"
            class="upload-file"
            :file-data="GrantForm.files.technical.appQuotes"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appQuotes"
            >
          </upload-file>
        </div>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appJustification">{{$t('small_technical_grants.document_upload__budget_upload_title_3')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appJustification"
            class="upload-file"
            :file-data="GrantForm.files.technical.appJustification"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appJustification"
            >
          </upload-file>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <h4 class="card-title">{{$t('small_technical_grants.document_upload__other_documents_card_title')}}</h4>
        <p>{{$t('small_technical_grants.document_upload__other_documents_info')}}</p>
        <table class="mt-5 mb-2" width="100%">
          <thead>
            <th>Name</th>
            <th>Upload</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in GrantForm.model.technical.otherDocuments" :key="'result_'+index">
              <td>
                <textarea
                  class="form-control"
                  :placeholder="$t('small_technical_grants.document_upload__other_documents_placeholder')"
                  v-model="item.result"
                >
                </textarea>
              </td>
              <td>
                <upload-file
                  v-if="GrantForm.initialized"
                  v-model="GrantForm.files.technical['otherDocuments' + (index+1)]"
                  class="upload-file"
                  :file-data="GrantForm.files.technical['otherDocuments' + (index+1)]"
                  :is-editable="GrantForm.isEditable"
                  :size-limit="GrantForm.fileSizeLimit"
                  :section="'technical.otherDocuments' + (index + 1)"
                  >
                </upload-file>
              </td>
            </tr>
          </tbody>
        </table>

        <base-button
          type="primary"
          @click.native="addOtherDocument"
          class="ml-2"
          >
          <i class="tim-icons icon-simple-add mr-2"></i> {{$t('small_technical_grants.logical_framework__add_row_button_title')}}
        </base-button>
        <span class="ml-3">{{$t('small_technical_grants.logical_framework__add_row_button_info')}}</span>
      </div>
    </div>

  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        downloadFiles: GrantForm.regionId != 2 ? [
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/1.BIOPAMA_STG_Application_Template.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/1.BIOPAMA_STG_Formulaire_de_demande.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/2.BIOPAMA_STG_Applicant_Declaration.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/2.BIOPAMA_STG_Declaration_du_demandeur.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/3.BIOPAMA_Co-Applicant_Mandate.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/3.BIOPAMA_STG_Mandat_du_co-candidat.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/4.BIOPAMA_STG_ESMS questionnaire.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/4.BIOPAMA_STG_Questionnaire_SGES.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/5.BIOPAMA_STG_Due_Diligence_Questionnaire.docx',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/5.BIOPAMA_STG_Questionnaire_de_capacite.docx'
          },
          {
            en: '/files/en/STG/Region/'+GrantForm.regionId+'/6.BIOPAMA_AC_STG_Budget_EN.xls',
            fr: '/files/fr/STG/Region/'+GrantForm.regionId+'/6.BIOPAMA_STG_Petites_Subvention_Technique_Budget_FR.xls'
          },
        ] : [
          {
            en: '/files/en/STG/Region/2/1.BIOPAMA_STG_Application_Template.docx',
            fr: '/files/fr/STG/Region/2/1.BIOPAMA_STG_Application_Template.docx'
          },
          {
            en: '/files/en/STG/Region/2/2.BIOPAMA_STG_Applicant_Declaration.docx',
            fr: '/files/fr/STG/Region/2/2.BIOPAMA_STG_Applicant_Declaration.docx'
          },
          {
            en: '/files/en/STG/Region/2/3.BIOPAMA_Co-Applicant_Mandate.docx',
            fr: '/files/fr/STG/Region/2/3.BIOPAMA_Co-Applicant_Mandate.docx'
          },
          {
            en: '/files/en/STG/Region/2/4.BIOPAMA_STG_Logical_framework.xlsx',
            fr: '/files/fr/STG/Region/2/4.BIOPAMA_STG_Logical_framework.xlsx'
          },
          {
            en: '/files/en/STG/Region/2/5.BIOPAMA_STG_Due_Diligence_Questionnaire.docx',
            fr: '/files/fr/STG/Region/2/5.BIOPAMA_STG_Due_Diligence_Questionnaire.docx'
          },
          {
            en: '/files/en/STG/Region/2/6.BIOPAMA_AC_STG_Budget_EN.xls',
            fr: '/files/fr/STG/Region/2/6.BIOPAMA_AC_STG_Budget_EN.xls'
          },
        ]
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      addOtherDocument()
      {
        if (!GrantForm.model.technical.otherDocuments)
        {
          GrantForm.model.technical.otherDocuments = [];
        }

        GrantForm.model.technical.otherDocuments.push({});
        this.$forceUpdate();
      },
      mounted()
      {
        this.addOtherDocument();
      },
    }
  }
</script>
<style lang="scss" scoped>
.table-bordered td,
.table-bordered th
{
  padding: 20px;
}

.file-caption
{
  margin-right: 10px;
  display: inline-block;
  width: 60%;
}

.upload-file
{
  display: inline-block;
  margin-bottom: -4px;
}

.form-group
{
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
}

.card-title
{
  display: inline-block;
  width: 54.3%;
  margin-bottom: 1.75rem !important;
}
</style>
